export default __webpack_public_path__ + "static/media/opensea.dd8f219c.svg";